export default __webpack_public_path__ + "static/media/TimN.5482d598.png";